@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600&display=swap');

:host {
  font-family: 'Inter', sans-serif;

  .hemfixarna {
    &_widgetstyles {
      label {
        cursor: pointer;
      }
      > div {
        display: flex;
        gap: 1rem;
      }
      h5 {
        margin: 1rem 0;
      }
    }
    &_example {
      margin-bottom: 16px;
      background: #000;
      padding: 16px;
      color: #fff;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      max-width: 500px;
      box-sizing: border-box;
      position: relative;

      &--tooltip {
        background: #000;
        top: -48px;
        font-size: 16px;
        left: 40%;
        color: white;
        padding: 8px;
        position: absolute;
        opacity: 0;
        &::after {
          content: '';
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #000 transparent transparent transparent;
        }
      }
      &:hover {
        .hemfixarna_example--tooltip {
          opacity: 1;
        }
      }
      p {
        font-size: 14px;
      }
      img {
        filter: invert(1);
      }
    }
    &_install {
      display: grid;
      gap: 8px;
      margin-top: 16px;
    }
    &_product--label {
      background: #e1e0f5;
    }
    &_categories {
      max-height: 100%;
      overflow: auto;
      position: relative;
      &--label {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px;
        button {
          background: #3f3a92;
          border: none;
          font-weight: 600;
          padding: 3.2px 9.6px;
          border-radius: 10px;
          margin-right: 8px;
          color: #ece8e8;
          &:active {
            transform: scale(0.95);
          }
        }
        &--big {
          font-weight: 600;
          border-bottom: 1px solid black;
        }
      }
    }
  }
  p {
    margin: 0;
  }
  span {
    color: darkolivegreen;
    font-size: 10px;
  }
  button {
    cursor: pointer;
  }
  > div:not(.hemfixarna_hosted) {
    grid-template-columns: 1fr 1fr;
  }
  .hemfixarna_hosted {
    .hemfixarna_scripts {
      display: none;
    }
  }
  > div {
    display: grid;
    gap: 32px;
    width: 100%;
    height: 100vh;
    place-items: center;
    overflow: hidden;
    padding: 16px 32px;
    box-sizing: border-box;
    > * {
      width: 100%;
    }
    > div {
      max-width: 500px;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      ul {
        gap: 1px;
        display: grid;
      }
      li {
        padding-left: 16px;
        background: #fff;
      }
    }
  }
}
